import OrnaLogo from 'src/assets/ORNA Square Logo, transparent bg.png'
import { APP_ENV } from 'src/env'
import { cn } from 'src/utils/cn'
import useLogout from 'src/utils/hooks/useLogout'

export default function MobilePlaceholder() {
    const logout = useLogout()

    return (
        <div
            className={cn(
                'hidden h-full w-full place-items-center',
                APP_ENV.REACT_APP_LOCAL === 'no' &&
                    APP_ENV.REACT_APP_ENVIRONMENT === 'production' &&
                    'grid lg:hidden'
            )}
        >
            <div className="flex flex-col items-center justify-center">
                <img
                    src={OrnaLogo}
                    alt="ORNA Inc."
                    className="aspect-square w-[110px]"
                />
                <h1 className="mt-4 text-center text-xl font-bold">
                    We are improving the mobile experience. Please, sign in
                    using a desktop for now
                </h1>
                <button
                    onClick={logout}
                    className="mt-10 rounded-md bg-primary-red-500 px-4 py-2 uppercase text-white"
                >
                    Logout
                </button>
            </div>
        </div>
    )
}
